import { DateTime } from 'luxon';

export const DEFAULT_NO_YEAR = false;

export const DEFAULT_LEAP_YEAR = 1996;

const ASSUMED_AGE = 25;

export const DEFAULT_YEAR = DateTime.local().year - ASSUMED_AGE;

export function getDefaultBirthday(noYear) {
  const { day, month, year } = DateTime.local();
  const defaultBirthday = { day, month };
  return noYear
    ? defaultBirthday
    : { ...defaultBirthday, year: year - ASSUMED_AGE };
}
